module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/privacy-connections-865fac891d3f643cbd0c73d9057f42e1.png";